import "./css/App.css";

import * as Sentry from "@sentry/react";

import App from "./js/App";
import { Integrations } from "@sentry/tracing";
import React from "react";
import ReactDOM from "react-dom";
import { Config, getConfig } from "js/services/config";

const sentryDsn = getConfig(Config.SENTRY_DSN, "");

const currentEnv = getConfig(Config.CURRENT_ENV, "unknown");
Sentry.init({
  dsn: sentryDsn,
  integrations: [new Integrations.BrowserTracing()],
  environment: currentEnv,
  tracesSampleRate: 1.0, // capturing 100% of traffic; will reduce if too noisy
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
